var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6086 8.57094H7.56154C4.93198 8.57094 2.80029 10.7026 2.80029 13.3322V23.2118C2.80029 24.5265 3.86613 25.5924 5.18092 25.5924H6.19268C7.50746 25.5924 8.6201 24.4658 8.6201 23.151V22.1988M28.392 8.57091H32.4391C35.0686 8.57091 37.2003 10.7026 37.2003 13.3322V23.2117C37.2003 24.5265 36.1345 25.5924 34.8197 25.5924H33.8079C32.4931 25.5924 31.3774 24.5035 31.3774 23.1888V22.2365M19.9408 28.7467V34.7578M18.1553 34.7578H21.8453C27.1044 34.7578 31.3678 30.4944 31.3678 25.2353V15.7128C31.3678 9.79628 26.5715 5 20.655 5H19.3456C13.4291 5 8.63281 9.79628 8.63281 15.7128V25.2353C8.63281 30.4944 12.8962 34.7578 18.1553 34.7578ZM23.0355 25.5924C23.0355 27.3016 21.6499 28.6872 19.9407 28.6872C18.2315 28.6872 16.8459 27.3016 16.8459 25.5924C16.8459 23.8832 18.2315 22.4976 19.9407 22.4976C21.6499 22.4976 23.0355 23.8832 23.0355 25.5924Z",
    stroke: "#323232",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7831 17.3913C15.7831 17.8423 15.4175 18.2079 14.9665 18.2079C14.5154 18.2079 14.1498 17.8423 14.1498 17.3913C14.1498 16.9402 14.5154 16.5746 14.9665 16.5746C15.4175 16.5746 15.7831 16.9402 15.7831 17.3913ZM25.7831 17.3913C25.7831 17.8423 25.4175 18.2079 24.9665 18.2079C24.5154 18.2079 24.1498 17.8423 24.1498 17.3913C24.1498 16.9402 24.5154 16.5746 24.9665 16.5746C25.4175 16.5746 25.7831 16.9402 25.7831 17.3913Z",
    stroke: "#323232",
    strokeWidth: 1.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog);
export default __webpack_public_path__ + "static/media/Dog.31f024b7f2c49f28951043736f7eb791.svg";
export { ForwardRef as ReactComponent };